export default class Base {
  public data!: unknown

  public constructor(data: unknown) {
    this.data = data
  }

  public val(key: string) {
    // @ts-ignore
    return this.data[key]
  }
}
